import React, { Component } from 'react';
import './index.scss';
import CrgtEvent from '../CrgtEvent';
import _ from 'lodash';
export default class Button extends Component {

  render() {
    const { size,  href, target, cid, vid, nativePage, nativePath, externalUrl, event = 'doNothing', handleChangePage, router,style={} } = this.props;
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target))? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openAudio') {
      params = !_.isNil(cid) ? { cid } : {}
    }
    if (event === 'openNativeView') {
      params =  { nativePage, externalUrl }
    } 
    if (event === 'openVideoChannel') {
      params =  { nativePath }
    }
    if (event === 'openReader') {
      params =  { nativePath }
    }
    if (event === 'shareAndGrantCoupon') {
      const { shareInfo,modalInfo } = this.props;
      params = {shareInfo, modalInfo};
    }
    const clickEvent = !_.isEmpty(event) ? (event !== 'navLink' ? function () {  CrgtEvent[`${event}`](params)}: ()=>{handleChangePage && handleChangePage(router)}) :null;
    const btnClass = size === 'default' ? 'default-btn' : null;
 
    return(
          <button className={btnClass} style={style} onClick={clickEvent}>
            {this.props.children}
          </button>
     )
  }
}